import { CriteriaBase } from '@/shared/models/CriteriaBase.model';
import { EtatIntrant } from '@/shared/enums/EtatIntrant.enum';
import { EtatDeclarationIntrantProducteur } from '@/shared/enums/EtatDeclarationIntrantsProducteur.enum';
// Énumérations.
import { ArreteTarifaireCode } from '@/shared/enums/ArreteTarifCode.enum';
import { EtatDeclarationPos } from '@/shared/enums/EtatDeclarationPos.enum';
import { DateHelper } from '../shared/helpers/DateHelper';

/**
 * Liste des filtres possible pour récupérer la liste des déclarations d'intrant.
 */
export class DeclarationPosCriteria extends CriteriaBase {
    /**
     * L'ensemble des contrats d'achat (installations) liés aux intrants.
     */
    public contratAchatGroupeIds: number[];

    /**
     * Le mois de déclaration.
     */
    public mois?: string;

    /**
     * Filtre sur les états des déclarations.
     */
    public etatDeclarationPos?: EtatDeclarationPos;

    /**
     * Début de la période de filtrage.
    */
    public debutPeriode?: string;

    /**
     * Fin de la période de filtrage.
     */
    public finPeriode?: string;

    /**
     * Initialise les valeurs par défaut du filtre de factures.
     */
    constructor() {
        super();
        this.contratAchatGroupeIds = [];
        this.etatDeclarationPos = undefined;
        // Année précédente par défaut.
        this.mois = new Date().toDateString();

        // On initialise les dates pour filtrer les déclarations sur la période du mois courant et des quatres mois précédents.
        const today = new Date();
        const debutPeriode = new Date(today.getFullYear(), today.getMonth() - 4);
        // Pour récupérer le dernier jour d'un mois, on initialise une date au mois voulu + 1 et le jour à 0.
        // Exemple : new Date(2020, 2, 0) => 2020-02-29. 2 correspond au mois de Mars.
        const finPeriode = new Date(today.getFullYear(), today.getMonth(), 0);
        this.finPeriode = DateHelper.creerDate(finPeriode.getFullYear(), finPeriode.getMonth() + 1, finPeriode.getDate());
        this.debutPeriode = DateHelper.creerDate(debutPeriode.getFullYear(), debutPeriode.getMonth() + 1, 1);
    }
}
